<div class="holder">
    @if (!viewState.vakmanMode && (Features.WorkordersTtmsSave | hasFeature)) {
        <div class="mapselector workorder-bar d-none d-md-flex flex-column" [class.expanded]="viewState.workorder">
            <div>
                <div class="p-4 pb-3">
                    <h3>Werkopdracht</h3>
                </div>
                <mat-divider></mat-divider>
            </div>
            <div class="p-4 pb-0 flex-fill">
                <app-workorder-compose [project]="project"
                                       [filteredTtms]="filteredTtms"
                                       [ttmTypes]="ttmTypes"
                                       [ttmStatuses]="ttmStatuses"
                                       [selectionPolygon]="selectionPolygon"
                                       [mapSelectionEnabled]="selectionEnabled"
                                       (updatedWorkorder)="fgWorkorder.updateValueAndValidity()"
                                       (selectedWorkorder)="composingWorkorder=$event"
                                       (toggleSelection)="toggleSelection()"></app-workorder-compose>
            </div>
        </div>
    }
    <div class="mapselector search-bar" [class.expanded]="viewState.search">
        @if (project) {
            <div class="p-4 pb-0">
                <h3>Zoek op:</h3>
                <div class="search-input">
                    <mat-form-field class="w-100" color="accent">
                        <mat-label>Zoeken</mat-label>
                        <input id="ttmSearchInput" [formControl]="fcSearch" matInput placeholder="Zoeken...">
                        @if (fcSearch.value) {
                            <mat-icon (click)="fcSearch.reset()" matRipple matSuffix
                                      class="fa-solid fa-xmark"></mat-icon>
                        } @else {
                            <mat-icon matSuffix class="fa-solid fa-magnifying-glass"></mat-icon>
                        }
                    </mat-form-field>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="search-list p-4 pt-0">

                <div class="result-text" *ngIf="searchResults?.length || fcSearch.value">
                    {{ searchResults?.length > 0 ? searchResults?.length : 'Geen' }} Resultaten
                </div>
                @for (ttm of searchResults; track ttm.id) {
                    <div matRipple class="search-item" (click)="searchZoomToTtm(ttm)">
                        <div class="image" app-svg-as-img [svg]="ttm.entities[0]?.plain_image?.svg">
                            <small *ngIf="ttm.type?.count"><i class="fa fa-calculator"></i> {{ ttm.amount ?? 1 }}</small>
                        </div>
                        <div class="info">
                            <div class="w-100">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        #{{ ttm.id }}
                                    </div>
                                    <small *ngIf="ttm.type?.count"><i class="fa fa-calculator "></i> {{ ttm.amount ?? 1 }}</small>
                                </div>
                                <small>{{ (ttmTypes | byKey : ttm.type_key)?.name }}</small>
                                <br>
                                <app-status-chip [statusKey]="ttm.status_key" [ttmStatuses]="ttmStatuses"></app-status-chip>
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                }
            </div>
        }
    </div>
    <div class="mapselector filter-bar" [class.expanded]="viewState.filter">
        <div class="p-4 pb-3 pe-3">
            <h3>Filters</h3>
            <div class="col-24 pb-2 pt-2" *ngIf="workorder">
                <h5>Werkopdracht</h5>
                <h3>{{ workorder.id_4ps }}</h3>

                <mat-slide-toggle [formControl]="fcHideOutsideWorkorder">Verberg maatregelen buiten werkopdracht</mat-slide-toggle>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div *ngIf="fcHideOutsideWorkorder?.value && workorder && scopedTtms?.length === 0" class="text-danger my-3 d-flex gap-2 align-items-center px-3">
            <i class="fa fa-exclamation-triangle"></i>
            <span>Er zijn geen maatregelen beschikbaar in deze werkopdracht</span>
        </div>
        @if (project) {
            <div class="p-4 pb-0">

                <mat-accordion class="clean-accordion">
                    <mat-expansion-panel #panelDrawings *ngIf="fgDrawings">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="justify-content-between"
                                             [matBadgeHidden]="panelDrawings.expanded || ((fgDrawings | countEnabledFgItems : fgDrawings.value) === (workorder?.drawings | ifNotNull : 'drawing')?.length)"
                                             matBadgeColor="warn"
                                             [matBadge]="'' + (fgDrawings | countEnabledFgItems : fgDrawings.value)"
                                             matBadgePosition="after">
                                Tekening
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div [formGroup]="fgDrawings" class="d-flex flex-column gap-2">
                            @if (project.drawings?.length === 0) {
                                <i>Er zijn geen tekeningen voor dit project beschikbaar</i>
                            }
                            @if (workorder && fcHideOutsideWorkorder.value) {
                                @for (drawing of workorder.drawings | ifNotNull : 'drawing'; track drawing.id) {
                                    @if (fgDrawings.controls[drawing.drawing.id]) {
                                        <mat-checkbox [formControlName]="drawing.drawing.id"
                                                      class="checkbox-drawing"
                                                      [class.highlight]="!!(composingWorkorder?.drawings | byId : drawing.id : 'drawing_id')"
                                                      [class.downlight]="drawing.drawing.entities_count < 1">
                                            <b>{{ drawing.drawing.filename }} ({{ drawing.drawing.revision }})</b><br>
                                            <small class="drawing-name"
                                                   matTooltipPosition="after"
                                                   [matTooltip]="drawing.drawing.name | drawingName">
                                                {{ drawing.drawing.name | drawingName }}
                                            </small>
                                            <small>{{ drawing.drawing.date | date : 'EEE d MMM yyyy' }}</small>
                                        </mat-checkbox>
                                    }
                                }
                            } @else {
                                @for (drawing of project.drawings | orderDrawings; track drawing.id) {
                                    <mat-checkbox [formControlName]="drawing.id" class="checkbox-drawing"
                                                  [class.highlight]="!!(composingWorkorder?.drawings | byId : drawing.id : 'drawing_id')"
                                                  [class.downlight]="drawing.entities_count < 1">
                                        <b>{{ drawing.filename }} ({{ drawing.revision }})</b><br>
                                        <small class="drawing-name"
                                               matTooltipPosition="after"
                                               [matTooltip]="drawing.name | drawingName">
                                            {{ drawing.name | drawingName }}
                                        </small>
                                        <small>{{ drawing.date | date : 'EEE d MMM yyyy' }}</small>
                                    </mat-checkbox>
                                }
                            }
                        </div>
                    </mat-expansion-panel>
                    <mat-divider class="my-2"></mat-divider>
                    @if (!viewState.vakmanMode) {
                        <mat-expansion-panel #panelWorkorder *ngIf="fgWorkorder">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="justify-content-between"
                                                 [matBadgeHidden]="panelWorkorder.expanded || ((fgWorkorder | countEnabledFgItems : fgWorkorder.value) === (fcWorkorderIncluding.value ? project.workorders.length : 0))"
                                                 matBadgeColor="warn"
                                                 [matBadge]="'' + (fgWorkorder | countEnabledFgItems : fgWorkorder.value)"
                                                 matBadgePosition="after">
                                    Werkopdracht
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div [formGroup]="fgWorkorder" class="d-flex flex-column">
                                @for (workorder of project.workorders; track workorder.id) {
                                    <mat-checkbox [formControlName]="workorder.id" [class.highlight]="composingWorkorder?.id === workorder.id">
                                        {{ workorder.soort | lowercase }}
                                        &middot;
                                        <small>{{ workorder.id_4ps }}</small>
                                        ({{ workorder.workorders_has_ttms?.length ?? '-' }})<br>
                                        {{ workorder.planned_startdate | codaltDate : 'EE d MMM \'\'yy H:mm' }}
                                        <br>
                                    </mat-checkbox>
                                }
                            </div>
                            <div class="d-flex justify-content-between">
                                <a class="select-all" (click)="this.fcWorkorderAll.setValue(!this.fcWorkorderAll.value)">
                                    {{ fcWorkorderAll.value ? 'de' : '' }}selecteer alle
                                </a>

                                <mat-slide-toggle [formControl]="fcWorkorderIncluding">
                                    {{ fcWorkorderIncluding.value ? 'Insluiten' : 'Uitsluiten' }}
                                </mat-slide-toggle>
                            </div>
                        </mat-expansion-panel>
                        <mat-divider class="my-2"></mat-divider>
                    }
                    <mat-expansion-panel #panelStatus *ngIf="fgStatus && ttmStatuses">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="justify-content-between"
                                             [matBadgeHidden]="panelStatus.expanded || (fgStatus | countEnabledStatuses : ttmStatuses : project.ttms : fgStatus.value) == (ttmStatuses | presentTtmStatuses : project.ttms)?.length"
                                             matBadgeColor="warn"
                                             [matBadge]="fgStatus | countEnabledStatuses : ttmStatuses : project.ttms : fgStatus.value"
                                             matBadgePosition="after">
                                Status
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div [formGroup]="fgStatus" class="d-flex flex-column">
                            @for (status of ttmStatuses | presentTtmStatuses : scopedTtms : scopedTtms?.length; track status.key) {
                                <mat-checkbox [formControlName]="status.key">
                                    <i class="fa fa-circle" [style.color]="'#' + status.color"></i>
                                    {{ status.name }}
                                    ({{ (scopedTtms | filter : status.key : 'status_key')?.length }})
                                </mat-checkbox>
                            }
                        </div>
                        <a class="select-all" (click)="this.fcStatusAll.setValue(!this.fcStatusAll.value)">
                            {{ fcStatusAll.value ? 'de' : '' }}selecteer alle
                        </a>
                    </mat-expansion-panel>
                    <mat-divider class="my-2"></mat-divider>
                    <mat-expansion-panel #panelType *ngIf="fgType && ttmTypes">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="justify-content-between"
                                             [matBadgeHidden]="panelType.expanded || (fgType | countEnabledTtmTypes : ttmTypes : project.ttms : fgType.value) == (ttmTypes | presentTtmTypes : project.ttms)?.length"
                                             matBadgeColor="warn"
                                             [matBadge]="fgType | countEnabledTtmTypes : ttmTypes : project.ttms : fgType.value"
                                             matBadgePosition="after">
                                Soorten
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div [formGroup]="fgType" class="d-flex flex-column">
                            @for (type of ttmTypes | presentTtmTypes : scopedTtms : scopedTtms?.length; track type.key) {
                                <mat-checkbox [formControlName]="type.key">
                                    {{ type.name }} ({{ scopedTtms | countAmountOfTtms : type : scopedTtms?.length }})
                                </mat-checkbox>
                            }
                        </div>
                        <a class="select-all" (click)="this.fcTypeAll.setValue(!this.fcTypeAll.value)">
                            {{ fcTypeAll.value ? 'de' : '' }}selecteer alles
                        </a>
                    </mat-expansion-panel>
                    @if (!viewState.vakmanMode && (Features.WorkordersTtmsSave | hasFeature)) {
                        <mat-divider class="my-2"></mat-divider>
                        <mat-expansion-panel #panelSelection>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="justify-content-between">
                                    Selectie
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="pb-2 pt-1">
                                <button mat-stroked-button (click)="toggleSelection()">
                                    {{ selectionEnabled ? 'Huidige selectie sluiten' : 'Selectie maken op de kaart' }}
                                </button>
                            </div>
                        </mat-expansion-panel>
                    }

                    <mat-divider class="my-2"></mat-divider>
                    @if (fgOther) {
                        <mat-expansion-panel #panelOther>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="justify-content-between"
                                                 [matBadgeHidden]="panelOther.expanded || (fgOther | countEnabledFgItems : fgOther.value) === 0"
                                                 matBadgeColor="warn"
                                                 [matBadge]="'' + (fgOther | countEnabledFgItems : fgOther.value)"
                                                 matBadgePosition="after">
                                    Overig
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div [formGroup]="fgOther" class="d-flex flex-column">
                                <mat-checkbox formControlName="withRemark">
                                    Met opmerking
                                </mat-checkbox>
                            </div>
                            <a class="select-all" (click)="this.fcOtherAll.setValue(!this.fcOtherAll.value)">
                                {{ fcOtherAll.value ? 'de' : '' }}selecteer alles
                            </a>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
        }
    </div>
    <google-map
        height="100%"
        width="100%"
        #googleMap
        (mapRightclick)="addPointToSelection($event)"
        [center]="center"
        [zoom]="setZoom"
        [mapTypeId]="$any(effectiveMapTypeId)"
        [class.ttm-expanded]="viewState.ttms"
        class="zoom-{{actualZoom}} maptype-{{mapTypeId}}"
        [options]="options">
        <div class="controls-left" *ngIf="project">
            @if (viaWorkorder) {
                <div routerLink="/{{Routenames.WorkOrders}}" [queryParams]="{workorderId: viaWorkorder}" tabindex="1" matTooltip="Terug naar werkopdracht"
                     matTooltipPosition="after">
                    <i class="fa fa-arrow-left-from-arc"></i>
                </div>
            } @else if (viaTicket) {
                <div [routerLink]="['/', Routenames.TtmTickets, viaTicket]" tabindex="1" matTooltip="Terug naar ticket" matTooltipPosition="after">
                    <i class="fa fa-arrow-left-from-arc"></i>
                </div>
            } @else {
                <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}" tabindex="1" matTooltip="Verlaat project" matTooltipPosition="after">
                    <i class="fa fa-arrow-left-from-arc"></i>
                </div>
            }
            <div (click)="toggleFilterBar()" [class.active]="viewState.filter" tabindex="2" matTooltip="Filters" matTooltipPosition="after">
                @if (viewState.filter) {
                    <i class="fa-solid fa-xmark"></i>
                } @else {
                    <i class="fa fa-filter"></i>
                }
            </div>
            <div (click)="toggleSearchBar()" [class.active]="viewState.search" tabindex="3" matTooltip="Zoeken" matTooltipPosition="after">
                @if (viewState.search) {
                    <i class="fa-solid fa-xmark"></i>
                } @else {
                    <i class="fa fa-search"></i>
                }
            </div>
            <div
                (mouseenter)="openMapMenu()"
                (mouseleave)="scheduleCloseMapMenu()"
                #mapMenuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="mapMenu"
                (click)="$event.preventDefault()">
                <i class="fa fa-layer-group"></i>

                <mat-menu
                    class="map-layer-menu"
                    #mapMenu="matMenu"
                    [hasBackdrop]="isMobileViewport"
                    xPosition="after"
                    (closed)="onMapMenuClosed()">
                    <div
                        class="map-menu-content"
                        (mouseenter)="cancelCloseMapMenu()"
                        (mouseleave)="scheduleCloseMapMenu()">
                        <button mat-menu-item (click)="setMapType('roadmap')" [class.active]="mapTypeId === 'roadmap'">
                            <mat-icon>map</mat-icon>
                            <span>Kaart</span>
                        </button>
                        <button mat-menu-item (click)="setMapType('BGT')" [class.active]="mapTypeId === 'BGT'">
                            <mat-icon>layers</mat-icon>
                            <span>Terrein</span>
                        </button>
                        <button mat-menu-item (click)="setMapType('hybrid')" [class.active]="mapTypeId === 'hybrid'">
                            <mat-icon>satellite</mat-icon>
                            <span>Satelliet</span>
                        </button>
                        <button mat-menu-item (click)="setMapType('OSM')" [class.active]="mapTypeId === 'OSM'">
                            <mat-icon>map_alt</mat-icon>
                            <span>StreetMap</span>
                        </button>
                        @for (drawingMap of selectedDrawingMaps; track drawingMap.id) {
                            <button mat-menu-item (click)="toggleDrawingMapOverlay(drawingMap); $event.stopPropagation()"
                                    [class.active]="isDrawingMapOverlayActive(drawingMap)">
                                <mat-icon>layers_alt</mat-icon>
                                <span>{{ drawingMap.xref_path | slice: (drawingMap.xref_path.lastIndexOf('\\') + 1) || (drawingMap.xref_path.lastIndexOf('/') + 1) }}</span>
                            </button>
                        }
                    </div>
                </mat-menu>
            </div>
            <div routerLink="/{{Routenames.TtmTickets}}" *ngIf="(Features.TtmTicketsDetailDelete | hasFeature) && !viewState.vakmanMode"
                 class="d-none d-md-block"
                 tabindex="5"
                 matTooltip="Tickets"
                 matTooltipPosition="after">
                <i class="fa fa-message-question"></i>
            </div>
            <div routerLink="/{{Routenames.Drawings}}"
                 [queryParams]="{search: 'P:' + project.id}"
                 *ngIf="(Features.DrawingsPaginated | hasFeature) && !viewState.vakmanMode"
                 class="d-none d-md-block"
                 tabindex="6"
                 matTooltip="Lijst van tekeningen"
                 matTooltipPosition="after">
                <i class="fa fa-draw-polygon"></i>
            </div>
            <div *ngIf="(Features.WorkordersTtmsSave | hasFeature) && !viewState.vakmanMode"
                 (click)="toggleWorkorder()"
                 [class.active]="viewState.workorder"
                 class="d-none d-md-block"
                 tabindex="7"
                 matTooltip="Werkopdracht"
                 matTooltipPosition="after">
                @if (viewState.workorder) {
                    <i class="fa-solid fa-xmark"></i>
                } @else {
                    <i class="fa-solid fa-file-lines"></i>
                }
            </div>
            <div (click)="centerGps()" tabindex="8"
                 matTooltip="Centreer op eigen locatie"
                 matTooltipPosition="after"
                 [class.dot]="viewState.gpsFailure">
                <i class="fa fa-location"></i>
            </div>
            <div (click)="reload()" *ngIf="Settings.versionUpdateAvailable"
                 tabindex="9"
                 matTooltip="Update beschikbaar voor TSNed app"
                 matTooltipPosition="after"
                 class="dot">
                <i class="fa fa-download"></i>
            </div>
        </div>

        @for (marker of historyMarkers(); track marker.id) {
            <map-advanced-marker
                [title]="marker.title"
                [position]="marker.position"
                [options]="{zIndex: 999}"></map-advanced-marker>
        }

        <map-advanced-marker
            *ngIf="gpsLocation"
            [position]="gpsLocation"
            [content]="gpsMarkerEl">
        </map-advanced-marker>

        <div #gpsMarkerEl class="gps-marker" aria-label="Current location marker"><img [src]="(25 |tsnedMarker).url"></div>


        @if (mapPolygonConfigMap && mapPolylineConfigMap) {
            @if (selectionPolygon) {
                @for (point of selectionPolygon; let i = $index; track i) {
                    <map-advanced-marker
                        [zIndex]="999"
                        (mapClick)="removePointFromSelectionPolygon($event, i)"
                        (mapDragend)="changeSelectionPolygon($event, i)"
                        [gmpDraggable]="true"
                        [position]="point"></map-advanced-marker>
                }
                @if (selectionPolygon?.length > 1) {
                    <map-polygon
                        [options]="mapPolygonConfigMap.get('selectionPolygon')"
                        [paths]="selectionPolygon"/>
                }
            }

            @if (actualZoom > 13) {
                @for (entity of filteredEntities; track entity.id) {
                    @if (entity.bbox) {
                        @if ((bounds | intersects : entity.bbox : entity.gnd) && actualZoom >= (entity | entityZoom)) {
                            <app-svg-overlay
                                zIndex="101"
                                [entity]="entity"
                                [map]="googleMap"></app-svg-overlay>
                            @if (entity.line && !mapPolylineConfigMap.has(entity.name)) {
                                <map-polyline
                                    [path]="entity.line | convertGeometry"
                                    [options]="{strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000',strokeOpacity: 1, strokeWeight: 2}"/>
                            }
                        }
                    } @else if (entity.line && mapPolygonConfigMap.has(entity.name)) {
                        <map-polygon
                            (polygonClick)="entityPolygonClick(entity)"
                            [paths]="entity.line | convertGeometry"
                            [options]="mapPolygonConfigMap.get(entity.name)"/>
                    } @else if (entity.line && mapPolylineConfigMap.has(entity.name)) {
                        <map-polyline
                            [path]="entity.line | convertGeometry"
                            [options]="mapPolylineConfigMap.get(entity.name) | overrideValues : {strokeColor: entity.color} "/>
                    }

                    @if (!entity.bbox && entity.line && !mapPolylineConfigMap.has(entity.name)) {
                        <map-polyline
                            [path]="entity.line | convertGeometry"
                            [options]="{strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000',strokeOpacity: 1, strokeWeight: 2}"/>
                    }
                }
            }
            @if (filteredTtms?.length && actualZoom <= 15) {
                @for (ttm of filteredTtms | clusterTtms : actualZoom : ttmStatuses; track $index) {
                    @for (clusterPolygon of ttm.clusterPolygons; track $index) {
                        <map-polygon
                            [paths]="clusterPolygon | convertPolygon"
                            [options]="mapPolygonConfigMap.get(ttm.colorGroup > 9 ? 'drawingZoomDark' : 'drawingZoomLight') | overrideValues : {fillColor: ttm.color, zIndex: ttm.colorGroup, strokeColor: ttm.color } "/>
                    }
                }
            }
        }

        @if (selectedTtm) {
            @for (image of ttmImagesMap.get(selectedTtm.id); track image.id) {
                @if (image.location) {
                    <map-advanced-marker
                        (mapClick)="openImage(image)"
                        [position]="image.location | geoLatLng"
                        [options]="{zIndex: 250}"
                        [content]="selectedTtm | marker : null : image.status : true"></map-advanced-marker>
                }
            }
        }

        @if (filteredTtms?.length && actualZoom > 13) {
            @for (ttm of filteredTtms; track ttm.id) {
                @if (ttm.type?.count && (bounds | intersects : null : ttm.entities[0]?.gnd : ttm.entities[ttm.entities.length - 1]?.gnd)) {
                    <map-advanced-marker
                        *ngIf="actualZoom < (ttm.entities[0] | entityZoom)"
                        [title]="ttm.type.name"
                        (mapClick)="ttmClick(ttm.id)"
                        [position]="ttm.entities[0].gnd | geoLatLng"
                        [content]="ttm | marker : ttm.status_key"></map-advanced-marker>
                    <map-advanced-marker
                        *ngIf="actualZoom < (ttm.entities[ttm.entities.length - 1] | entityZoom)"
                        [title]="ttm.type.name"
                        (mapClick)="ttmClick(ttm.id)"
                        [position]="ttm.entities[ttm.entities.length - 1].gnd | geoLatLng"
                        [content]="ttm | marker : ttm.status_key"></map-advanced-marker>
                }
                @if (ttm.comment_show_on_map && ttm.comment && actualZoom >= 15) {
                    @if (commentEntity(ttm); as ttmCommentEntity) {
                        @if (ttmCommentEntity | entityInBounds : bounds) {
                            <app-text-overlay
                                [entity]="ttmCommentEntity"
                                [text]="ttm.comment"
                                [zoom]="actualZoom"
                                [map]="googleMap"></app-text-overlay>
                        }
                    }
                }
                @for (entity of ttm.entities; track entity.handle) {
                    @if (bounds | intersects : entity.bbox : entity.gnd : (entity.line ?? entity.gnd)) {

                        @if (actualZoom >= (entity | entityZoom)) {
                            <app-svg-overlay
                                [ttmStatus]="ttm.status"
                                [entity]="entity"
                                *ngIf="entity.bbox"
                                [downlight]="!!fcSelectedTtm.value && fcSelectedTtm.value !== ttm.id"
                                [title]="ttm.type?.name"
                                [click]="ttmClick"
                                [map]="googleMap"></app-svg-overlay>
                            <app-svg-overlay
                                [ttmStatus]="ttm.status"
                                *ngIf="entity.gnd_handle && entity.gnd_handle !== entity.handle"
                                [entity]="entity"
                                [gnd]="true"
                                [downlight]="!!fcSelectedTtm.value && fcSelectedTtm.value !== ttm.id"
                                [click]="ttmClick"
                                [map]="googleMap"></app-svg-overlay>
                        } @else {
                            <map-advanced-marker
                                *ngIf="ttm.status?.show_in_overview && actualZoom < (entity | entityZoom : true) && !ttm.type?.count"
                                [position]="entity.gnd | geoLatLng"
                                (mapClick)="ttmClick(ttm.id)"
                                [options]="{zIndex: ttm.status?.color_group+100}"
                                [content]="ttm | marker : ttm.status_key "></map-advanced-marker>
                        }

                        @if ((entity.pole || entity.line) && actualZoom >= (entity | entityZoom)) {
                            @if (entity.gnd.coordinates?.length === 1) {
                                @if ((entity.pole || entity.line) && entity.bbox) {
                                    <map-circle
                                        (circleClick)="ttmClick(ttm.id)"
                                        [center]="entity.gnd | geoLatLng"
                                        [options]="{zIndex: 5, strokeColor:  '#' + ttm.status?.color}"
                                        [radius]=".7"></map-circle>
                                }

                                @if (entity.pole) {
                                    <map-polyline
                                        [options]="{zIndex: 5, strokeWeight:5, strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000'}"
                                        [path]="entity.pole | convertGeometry"/>

                                    @if (!entity.line) {
                                        <map-polyline
                                            [options]="{zIndex: 5, strokeWeight:2, strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000'}"
                                            [path]="[entity.gnd | geoLatLng, entity.pole | geoLatLng]"/>
                                    }
                                }
                            } @else {
                                @if (entity.pole) {
                                    <map-polyline
                                        [options]="{zIndex: 5, strokeWeight:2, strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000'}"
                                        [path]="entity.pole | convertGeometry"/>
                                }
                                @if (!entity.gnd_handle) {
                                    @for (coordinates of (entity.gnd | gndLine); track $index) {
                                        <map-polyline [options]="{zIndex: 5, strokeWeight: 8, strokeColor: '#' + ttm.status?.color}"
                                                      (polylineClick)="ttmClick(ttm.id)"
                                                      [path]="coordinates"/>
                                    }

                                    @if (!entity.line && entity.pole) {
                                        <map-polyline
                                            [options]="{zIndex: 5, strokeWeight:2, strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000'}"
                                            [path]="[entity.gnd | geoLatLng, entity.pole | geoLatLng]"/>
                                    }
                                }
                            }
                            @if (entity.line && mapPolylineConfigMap.has(entity.name)) {
                                @for (coordinates of (entity | dashedLine); track $index) {
                                    <map-polyline
                                        (polylineClick)="ttmClick(ttm.id)"
                                        [path]="coordinates"
                                        [options]="mapPolylineConfigMap.get(entity.name) | overrideValues : {strokeColor: entity.color} "/>
                                }

                            } @else if (entity.line && mapPolygonConfigMap.has(entity.name)) {
                                <map-polygon
                                    (polygonClick)="ttmClick(ttm.id)"
                                    [paths]="entity.line | convertGeometry"
                                    [options]="mapPolygonConfigMap.get(entity.name)"/>
                            } @else if (entity.line) {
                                <map-polyline
                                    [path]="entity.line | convertGeometry"
                                    [options]="{zIndex: 4, strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000',strokeOpacity: 1, strokeWeight: 2}"/>
                            }
                        }
                    }
                }
            }
        }

        @if (project) {
            <div class="ttm-list-toggle"
                 #ttmListToggle
                 (click)="toggleTtmList()"
                 (keyup.enter)="toggleTtmList()"
                 tabindex="10"
                 [class.loading]="filteredTtms?.length <= 0"
                 [class.open]="viewState.ttms"
                 matTooltip="{{viewState.ttms ? 'Sluit' : 'Open'}} balk met maatregelen"
                 matTooltipPosition="before">
                @if (!mobileControls || !fcSelectedTtm?.value) {
                    <div class="project">
                        {{ project?.name }}
                    </div>
                }
                @if (filteredTtms?.length > 0) {
                    <mat-icon>{{ viewState.ttms ? 'chevron_right' : 'menu_open' }}</mat-icon>
                } @else {
                    <mat-icon class="loading-icon">sync</mat-icon>
                }
            </div>
        }

        @if (Features.EntitiesMultiSave | hasFeature) {
            <app-map-mutator *ngIf="!activeTtm"
                             [mobileControls]="mobileControls"
                             [selectedTtm]="selectedTtm"
                             [viewState]="viewState"
                             [mergeTtms]="mergeTtms"
                             [splitTtm]="splitTtm"
                             [googleMap]="googleMap"
                             [filteredTtms]="filteredTtms"
                             [project]="project"
                             [selectedDrawingIds]="selectedDrawingIds"
                             [ttmTypes]="ttmTypes"
                             (ttmAdded)="onTtmAdded($event)"
                             (zoomToTtm)="zoomToTtm($event, true, true)"
                             [changeCenter]="changeCenter"></app-map-mutator>
        }
    </google-map>

    @if (filteredTtms?.length > 0) {
        <div class="ttm-list" [tabindex]="viewState.ttms ? 11 : -1" [class.expanded]="viewState.ttms" [class.image-drawer-open]="viewState.imageDrawer"
             #ttmList>
            <div class="row px-4 pt-4 pb-3">
                <div class="col-24 pb-2" *ngIf="workorder">
                    <h5>Werkopdracht</h5>
                    <h3>{{ workorder.id_4ps }}</h3>
                </div>
                <div class="col">
                    <h5>Project</h5>
                    <h4 class="mb-0">{{ project.name }}</h4>
                    <h6>{{ project.id_4ps }}</h6>
                </div>
                <div class="col">
                    <h5>Klant</h5>
                    <h4 class="mb-0">{{ project.customer?.name }}</h4>
                    <h6>{{ project.customer?.id_4ps }}</h6>
                </div>
            </div>
            <mat-divider class="my-2"></mat-divider>
            <div class="p-4">
                <mat-accordion class="clean-accordion" [class.has-expanded]="fcSelectedTtm.value">
                    @for (ttm of filteredTtms; let i = $index; track ttm.id) {
                        <mat-expansion-panel #panel [expanded]="fcSelectedTtm.value === ttm.id">
                            <mat-expansion-panel-header [tabIndex]="viewState.ttms ? i + 11 : '-1'" (click)="zoomToTtm(ttm, panel.expanded)">
                                @if (ttm.type_key === TtmTypes.deviations) {
                                    <div>
                                        <div class="flex-grow-1 ttm-nr-type">
                                            {{ (ttmTypes | byKey : ttm.type_key)?.name }}<br>
                                        </div>
                                        <div class="entity-text">
                                            {{ ttm.entities[0].attr?.text }}
                                        </div>
                                    </div>
                                } @else {
                                    <div class="ttm-image" app-svg-as-img [ttm]="ttm" (dblclick)="activeTtm = ttm">
                                        <div class="counts">
                                            <small *ngIf="ttm.type?.count"><i class="fa fa-calculator"></i> {{ ttm.amount ?? 1 }}</small>
                                            <small *ngIf="ttm.ttm_images_count"><i class="fa fa-camera"></i> {{ ttm.ttm_images_count ?? 0 }}</small>
                                            <small *ngIf="ttm.comment && ttm.comment.trim().length > 0"><i class="fa fa-comment"></i></small>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1 ttm-nr-type">
                                        {{ (ttmTypes | byKey : ttm.type_key)?.name }}<br>
                                    </div>
                                    <div class="status-info me-3">
                                        @if (ttm.status?.show_in_overview) {
                                            <app-status-chip [statusKey]="ttm.status_key" [ttmStatuses]="ttmStatuses"></app-status-chip>
                                        }
                                        <div class="status-date">
                                            {{ ttm.status_date | codaltDate : 'EE d MMM yy H:mm' }}
                                        </div>
                                    </div>
                                }

                            </mat-expansion-panel-header>
                            <div *ngIf="ttm.type_key === TtmTypes.temporary_road_markings" class="ps-4">
                                {{ linetypeNameMap.get(ttm.entities[0]?.attr?.linetype) }}
                            </div>
                            @if (ttmImagesMap.get(ttm.id)?.length > 0) {
                                <div class="images pt-3">
                                    @for (image of ttmImagesMap.get(ttm.id); track image.id) {
                                        <div class="image-wrap">
                                            <div class="image" (click)="openImage(image)" [style.border-color]="'#' + image.status?.color">
                                                <app-codalt-image url="ttm-images/image/{{image.id}}"></app-codalt-image>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            <div class="buttons pt-3">
                                @if (ttm.type_key !== TtmTypes.deviations && (Features.TtmsUpdateStatusSave | hasFeature)) {
                                    <button mat-stroked-button
                                            [tabindex]="viewState.ttms ? i + 11 : -1"
                                            class="status-box"
                                            (click)="updateStatus(ttm)">
                                        Status aanpassen
                                    </button>
                                } @else {
                                    <div class="flex-grow-1"></div>
                                }
                                <button mat-stroked-button
                                        (contextmenu)="menuTrigger.click();$event.preventDefault()"
                                        (touchstart)="activeTtmOrContext($event, menuTrigger, ttm)"
                                        (touchend)="activeTtmOrContext($event, menuTrigger, ttm)"
                                        (click)="activeTtmOrContext($event, menuTrigger, ttm)"
                                        color="accent"
                                        [tabindex]="viewState.ttms ? i + 11 : -1"
                                        class="flex-grow-0">
                                    <mat-icon>more_horiz</mat-icon>
                                </button>
                                <div [matMenuTriggerFor]="menu" #menuTrigger></div>
                                <mat-menu #menu="matMenu">
                                    @if (Features.TtmsHistoryDetail | hasFeature) {
                                        <button mat-menu-item (click)="ttmHistory(ttm)">
                                            <mat-icon>history</mat-icon>
                                            <span>Geschiedenis</span>
                                        </button>
                                    }
                                    <button mat-menu-item (click)="ttmTicket(ttm)" *ngIf="Features.TtmTicketsSave | hasFeature">
                                        <mat-icon>live_help</mat-icon>
                                        <span>Melden</span>
                                    </button>
                                    <button mat-menu-item (click)="ttmDetails(ttm)" *ngIf="Roles.Codalt | hasRole">
                                        <mat-icon>info</mat-icon>
                                        <span>Details</span>
                                    </button>
                                    <a mat-menu-item
                                       href="https://maps.google.com/?q={{ttm.entities[0]?.gnd.coordinates[0][1]}},{{ttm.entities[0]?.gnd.coordinates[0][0]}}"
                                       target="_blank">
                                        <mat-icon>explore</mat-icon>
                                        <span>Navigeer</span>
                                    </a>

                                    <button mat-menu-item (click)="copyTtmLink(ttm)">
                                        <mat-icon>link</mat-icon>
                                        <span>Delen</span>
                                    </button>

                                    <button mat-menu-item (click)="deleteTtm(ttm)" *ngIf="Features.TtmsDetailDelete | hasFeature">
                                        <mat-icon color="warn">delete</mat-icon>
                                        <span>Verwijderen</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </mat-expansion-panel>
                        <mat-divider class="my-2"></mat-divider>
                    }
                </mat-accordion>
            </div>
        </div>
    }
    <div class="ttm-details-overlay" [class.open]="activeTtm">
        <app-ttm-details *ngIf="activeTtm"
                         (close)="activeTtm = null"
                         (delete)="deleteTtm($event)"
                         (ticket)="ttmTicket($event)"
                         (details)="ttmDetails($event)"
                         (history)="ttmHistory($event)"
                         (updateImages)="updateImages($event)"
                         (updateTtm)="ttmUpdateSubject.next(true)"
                         (openLocation)="onLocationOpen($event)"
                         [ttm]="activeTtm"
                         [gpsLocation]="gpsLocation"
                         [ttmTypes]="ttmTypes"
                         [workorder]="workorder"
                         [ttmStatuses]="ttmStatuses"></app-ttm-details>
    </div>

    <div class="image-drawer-overlay" [class.open]="viewState.imageDrawer">
        <app-image-drawer
            [ttmImages]="ttmImagesWithMultiple"
            [currentImage]="imageDrawerCurrentImage"
            [ttmStatuses]="ttmStatuses"
            [ttmImageDistance]="ttmImageDistance"
            (close)="viewState.imageDrawer = false"
            (imageChange)="onImageDrawerImageChange($event)"
            (openLocation)="onLocationOpen($event)">
        </app-image-drawer>
    </div>
</div>


